import React from "react";
import { Link } from "react-router-dom";

// Project images
import colorglanz from "../../images/projects/colorglanz.png";
import everest from "../../images/projects/everest-woven-ark.png";
import letscode from "../../images/projects/letscode.png";
import maruthi from "../../images/projects/maruthi.png";
import priyanka from "../../images/projects/priryanka.png";
import spotmies from "../../images/projects/spotmies.png";
import vamsi from "../../images/projects/vamsi-dark.png";
import snr from "../../images/projects/snr1.png";
import sda from "../../images/projects/sda2.png";
import riq from "../../images/projects/riq.png";
import kkk from "../../images/projects/kkk1.png";

const projects = [
  { id: 1, image: everest, name: "Everest Woven Ark" },
  { id: 5, image: spotmies, name: "Spotmies" },
  { id: 9, image: sda, name: "SDA" },
  { id: 2, image: letscode, name: "Let's Code" },
  { id: 4, image: priyanka, name: "Priyanka Agro Farms" },
  // { id: 10, image: riq, name: "RIQ" },
  { id: 8, image: snr, name: "SNR" },
  { id: 6, image: vamsi, name: "Vamsi Events" },
  { id: 3, image: maruthi, name: "Maruthi" },
  { id: 7, image: colorglanz, name: "Colorglanz" },
  { id: 11, image: kkk, name: "KKK" },


];

const LovedByDevelopers: React.FC = () => {
  return (
    <section className="loved-by-developers py-100">
      <div className="container">
        {/* Section Header */}
        <div className="sec-title sec-title-center text-center mb-60">
          <span className="sub-title" style={{ color: "#fc9038" }}>
            Loved By Developers, Trusted By Enterprises
          </span>
          <h2 className="title" style={{ marginTop: "15px" }}>
            Trusted By <span style={{ color: "#fc9038" }}>Enterprises</span>
          </h2>
          <p style={{
            maxWidth: "700px",
            margin: "20px auto 0",
            fontSize: "18px",
            lineHeight: "1.7",
            color: "rgba(255, 255, 255, 0.7)"
          }}>
            We've helped our clients succeed by elevating their online presence and driving digital transformation. Join them to turn your vision into powerful, impactful results.
          </p>
        </div>

        {/* Projects Grid */}
        <div
          className="projects-grid"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "30px",
            marginTop: "50px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {projects.map((project) => (
            <div
              key={project.id}
              className="project-card"
              style={{
                background: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                borderRadius: "16px",
                padding: "30px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                minHeight: "180px",
                width: "250px",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(252, 144, 56, 0.1)";
                e.currentTarget.style.borderColor = "rgba(252, 144, 56, 0.3)";
                e.currentTarget.style.transform = "translateY(-5px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.03)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <img
                src={project.image}
                alt={project.name}
                style={{
                  maxWidth: "200px",
                  maxHeight: "120px",
                  objectFit: "contain",
                  filter: "grayscale(100%)",
                  opacity: 0.8,
                  transition: "all 0.3s ease",

                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.filter = "grayscale(0%)";
                  e.currentTarget.style.opacity = "1";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.filter = "grayscale(100%)";
                  e.currentTarget.style.opacity = "0.8";
                }}
              />
              {/* <span 
                style={{ 
                  marginTop: "15px", 
                  fontSize: "14px", 
                  color: "rgba(255, 255, 255, 0.6)",
                  textAlign: "center"
                }}
              >
                {project.name}
              </span> */}
            </div>
          ))}
        </div>

        {/* Stylish 50+ Projects Text */}
        <div
          className="text-center mt-60"
          style={{
            position: "relative"
          }}
        >
          <h3
            style={{
              fontSize: "clamp(28px, 4vw, 40px)",
              fontWeight: "800",
              background: "linear-gradient(135deg, #fc9038 0%, #ff6b35 50%, #fc9038 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              textAlign: "center",
              letterSpacing: "-2px",
              lineHeight: "1.1",
              textShadow: "0 0 40px rgba(252, 144, 56, 0.3)"
            }}
          >
            50+ Projects
          </h3>
          <p
            style={{
              fontSize: "18px",
              color: "rgba(255, 255, 255, 0.6)",
              marginTop: "15px",
              textAlign: "center"
            }}
          >
            Successfully Delivered Worldwide
          </p>
        </div>

        {/* CTA Button */}
        {/* <div className="text-center mt-60">
          <Link to="/project" className="thm-btn agency-btn">
            <span className="text">View All Projects</span>
            <span className="arrow">
              <span className="arrow-icon">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="5.22852"
                    y="17.3296"
                    width="17.888"
                    height="2.27149"
                    transform="rotate(-40.2798 5.22852 17.3296)"
                    fill="white"
                  />
                  <rect
                    x="7.75781"
                    y="6.25635"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 7.75781 6.25635)"
                    fill="white"
                  />
                  <rect
                    x="10.959"
                    y="6.52002"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 10.959 6.52002)"
                    fill="white"
                  />
                  <rect
                    x="14.1562"
                    y="6.78516"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 14.1562 6.78516)"
                    fill="white"
                  />
                  <rect
                    x="17.0957"
                    y="10.25"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 17.0957 10.25)"
                    fill="white"
                  />
                  <rect
                    x="16.832"
                    y="13.4517"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 16.832 13.4517)"
                    fill="white"
                  />
                  <rect
                    x="16.5684"
                    y="16.6538"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 16.5684 16.6538)"
                    fill="white"
                  />
                </svg>

                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="5.22852"
                    y="17.3296"
                    width="17.888"
                    height="2.27149"
                    transform="rotate(-40.2798 5.22852 17.3296)"
                    fill="white"
                  />
                  <rect
                    x="7.75781"
                    y="6.25635"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 7.75781 6.25635)"
                    fill="white"
                  />
                  <rect
                    x="10.959"
                    y="6.52002"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 10.959 6.52002)"
                    fill="white"
                  />
                  <rect
                    x="14.1562"
                    y="6.78516"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 14.1562 6.78516)"
                    fill="white"
                  />
                  <rect
                    x="17.0957"
                    y="10.25"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 17.0957 10.25)"
                    fill="white"
                  />
                  <rect
                    x="16.832"
                    y="13.4517"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 16.832 13.4517)"
                    fill="white"
                  />
                  <rect
                    x="16.5684"
                    y="16.6538"
                    width="2.27149"
                    height="2.27149"
                    transform="rotate(-40.2798 16.5684 16.6538)"
                    fill="white"
                  />
                </svg>
              </span>
            </span>
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default LovedByDevelopers;
